var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"mt-4",attrs:{"color":"info","label":"","outlined":""}},[_c('v-avatar',[_c('v-icon',{attrs:{"small":""}},[_vm._v(" fa-info ")])],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }